import Swiper from 'swiper'

const direction = 'horizontal'

var about = new Swiper ('.swiper-container', {
  // Optional parameters
  direction,
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 30,
  speed: 300,
  // Navigation arrows
  navigation: {
    nextEl: '.about .slider_control.next',
    prevEl: '.about .slider_control.prev',
  },
  breakpointsInverse: true,
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 18
    }
  },
  freeMode: true,
  grabCursor: true
})

// sliders with animations

async function getProperSliderInstance() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(portfolio.activeIndex)
    }, 1)
  })
}

function slidePortfolio() {
  const windowWidth = window.innerWidth
  const overlayContent = document.querySelector(`.portfolio .portfolio_overlay`)
  const overlayImage = document.querySelector(`.casestudy_images .portfolio_overlay`)
  const rectContent = overlayContent.getBoundingClientRect();
  const rectImages = overlayImage.getBoundingClientRect();
  
  if(rectContent.left < (windowWidth / 2)) {
    overlayContent.style.transform = 'translateX(100%)'
  } else {
    overlayContent.style.transform = 'translateX(-100%)'
  }

  if(rectImages.left < (windowWidth / 2)) {
    overlayImage.style.transform = 'translateX(100%)'
  } else {
    overlayImage.style.transform = 'translateX(-100%)'
  }
}

function slide(identifier) {
  const overlay = document.querySelector(`.${identifier}_overlay`)
  const rect = overlay.getBoundingClientRect();

  rect.left < 300 ? overlay.style.transform = 'translateX(100%)' : overlay.style.transform = 'translateX(-100%)'
}

const portfolioImages = new Swiper('.casestudy_images', {
  direction,
  sliderPerView: 1,
  effect: 'fade',
  spaceBetween: 19,
  speed: 100,
  loop: true,
  allowTouchMove: false,
  pagination: ' '
})

const portfolio = new Swiper('.portfolio_articles', {
  direction,
  sliderPerView: 1,
  navigation: {
    nextEl: '.portfolio .slider_controls .next',
    prevEl: '.portfolio .slider_controls .prev'
  },
  effect: 'fade',
  spaceBetween: 19,
  speed: 100,
  loop: true,
  pagination: ' ',
  preventInteractionOnTransition: true,
  on: {
    slideChange: async() => {
      const index = await getProperSliderInstance('portfolio')
      portfolioImages.slideTo(index)

      slidePortfolio()
    }
  }
})

const testimonials = new Swiper('.testimonials_slider', {
  direction,
  loop: true,
  sliderPerView: 1,
  speed: 100,
  spaceBetween: 20,
  effect: 'fade',
  navigation: {
    nextEl: '.testimonials_slider_controls .slider_control.next',
    prevEl: '.testimonials_slider_controls .slider_control.prev'
  },
  on: {
    slideChange: async() => {
      slide('testimonials')
    }
  }
})

const bullets = [
  { index: '01', tab: 'Discovery' },
  { index: '02', tab: 'Definition' },
  { index: '03', tab: 'Delivery' }
]

const ddd = new Swiper('.tabs', {
  direction,
  loop: false,
  sliderPerView: 1,
  speed: 50,
  effect: 'fade',
  navigation: {
    nextEl: '.ddd .slider_controls .next',
    prevEl: '.ddd .slider_controls .prev'
  },
  pagination: {
    el: '.tabs_nav',
    clickable: true,
    renderBullet(index, className) {
      return `<button class="tabs_nav_item ${ className }">${ bullets[index].index }: ${ bullets[index].tab }</button>`
    }
  },
  on: {
    slideChange: async() => {
      slide('ddd')
    }
  }
})